var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorReport',{attrs:{"isAlonePage":true,"defaultTab":"second"}})
}
var staticRenderFns = []

export { render, staticRenderFns }